var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 50,
    height: 70,
    viewBox: "0 0 50 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xE8\xBF\xB9_3",
    clipPath: "url(#clip0_83_469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.1952 44.1344L28.8038 69.7277L35.0545 60.7428L45.3799 64.555L37.2277 39.7786L21.1952 44.1344Z",
    fill: "#CD3414"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.4796 51.2678L24.677 51.5132L29.7639 68.2153L30.5665 67.9699L25.4796 51.2678Z",
    fill: "#FFCE45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.086 43.7339L36.2856 43.9866L42.5364 63.8622L43.3367 63.6095L37.086 43.7339Z",
    fill: "#FFCE45"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.9569 41.4114L3.80478 65.0986L14.9455 61.2874L20.6517 70L30.1627 44.679L11.9569 41.4114Z",
    fill: "#FE5629"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.0042 40.4695L6.39326 63.8834L7.19115 64.1438L14.8021 40.7299L14.0042 40.4695Z",
    fill: "#FFCE45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M27.5948 43.1816L18.8965 67.9574L19.6881 68.2364L28.3864 43.4606L27.5948 43.1816Z",
    fill: "#FFCE45"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M-0.000157581 24.8028C-0.000157581 23.6582 2.7843 22.7247 2.94164 21.6231C3.10184 20.4947 0.693095 18.816 1.00682 17.745C1.32627 16.6548 4.26044 16.5459 4.72578 15.5274C5.1959 14.4975 3.36026 12.2035 3.96673 11.2585C4.57702 10.3079 7.42251 11.034 8.15962 10.1827C8.89769 9.33047 7.77819 6.6113 8.62879 5.87179C9.47747 5.1342 12.0054 6.62946 12.9542 6.01702C13.8973 5.40841 13.5845 2.48382 14.6125 2.01183C15.629 1.54558 17.6325 3.69436 18.7205 3.37429C19.7904 3.05995 20.3168 0.165933 21.4439 0.00446425C22.5434 -0.152227 23.8584 2.47522 25.0008 2.47522C26.1432 2.47522 27.4572 -0.150316 28.5567 0.00637512C29.6829 0.166888 30.2102 3.06186 31.2801 3.3762C32.3682 3.69627 34.3716 1.54749 35.3881 2.01375C36.4161 2.48478 36.1043 5.41032 37.0464 6.01893C37.9952 6.63041 40.5222 5.13611 41.3719 5.87371C42.2224 6.61321 41.1029 9.33238 41.841 10.1846C42.5772 11.035 45.4227 10.3098 46.0339 11.2605C46.6413 12.2054 44.8047 14.4984 45.2749 15.5293C45.7402 16.5478 48.6744 16.6568 48.9938 17.7469C49.3075 18.8189 46.8988 20.4966 47.059 21.625C47.2154 22.7266 50.0008 23.6601 50.0008 24.8047C50.0008 25.9493 47.2163 26.8828 47.059 27.9844C46.8988 29.1128 49.3075 30.7915 48.9938 31.8625C48.6744 32.9527 45.7402 33.0616 45.2749 34.0801C44.8047 35.11 46.6404 37.404 46.0339 38.349C45.4236 39.2996 42.5781 38.5735 41.841 39.4248C41.1029 40.277 42.2224 42.9962 41.3719 43.7357C40.5232 44.4733 37.9952 42.9781 37.0464 43.5905C36.1033 44.1991 36.4161 47.1237 35.3881 47.5957C34.3716 48.0619 32.3682 45.9131 31.2801 46.2332C30.2102 46.5476 29.6838 49.4416 28.5567 49.603C27.4572 49.7597 26.1422 47.1323 24.9998 47.1323C23.8575 47.1323 22.5425 49.7597 21.443 49.603C20.3168 49.4425 19.7895 46.5476 18.7196 46.2332C17.6315 45.9131 15.6281 48.0619 14.6115 47.5957C13.5836 47.1246 13.8954 44.1991 12.9533 43.5905C12.0045 42.979 9.47747 44.4733 8.62783 43.7357C7.77724 42.9962 8.89674 40.277 8.15867 39.4248C7.42251 38.5744 4.57702 39.2996 3.96578 38.349C3.35835 37.404 5.19494 35.111 4.72483 34.0801C4.25948 33.0616 1.32532 32.9527 1.00587 31.8625C0.692141 30.7905 3.10088 29.1128 2.94068 27.9844C2.7843 26.8828 -0.00111116 25.9493 -0.00111116 24.8047L-0.000157581 24.8028Z",
    fill: "#FCAB28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M25 44.9513C36.1059 44.9513 45.1091 35.9307 45.1091 24.8031C45.1091 13.6756 36.1059 4.65488 25 4.65488C13.8941 4.65488 4.89091 13.6756 4.89091 24.8031C4.89091 35.9307 13.8941 44.9513 25 44.9513Z",
    fill: "#FFCE45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M25 45.3593C19.5198 45.3593 14.3676 43.221 10.4932 39.3382C6.61784 35.4553 4.48373 30.293 4.48373 24.8031C4.48373 19.3132 6.61784 14.15 10.4932 10.2681C14.3685 6.38518 19.5207 4.24691 25 4.24691C30.4793 4.24691 35.6324 6.38518 39.5068 10.2681C43.3822 14.151 45.5163 19.3132 45.5163 24.8031C45.5163 30.293 43.3822 35.4562 39.5068 39.3382C35.6315 43.221 30.4793 45.3593 25 45.3593ZM25 5.06381C14.1368 5.06381 5.29904 13.9188 5.29904 24.8031C5.29904 35.6874 14.1368 44.5424 25 44.5424C35.8632 44.5424 44.701 35.6874 44.701 24.8031C44.701 13.9188 35.8632 5.06381 25 5.06381Z",
    fill: "#FCAB28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M25 39.2331C32.954 39.2331 39.4019 32.7725 39.4019 24.8031C39.4019 16.8337 32.954 10.3732 25 10.3732C17.046 10.3732 10.5981 16.8337 10.5981 24.8031C10.5981 32.7725 17.046 39.2331 25 39.2331Z",
    fill: "#FFD733"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M36.9569 19.0858C36.9569 18.1667 36.8673 17.2695 36.7033 16.3981C34.0895 12.7512 29.8232 10.3732 25 10.3732C17.0462 10.3732 10.5981 16.8338 10.5981 24.8031C10.5981 25.7222 10.6877 26.6194 10.8517 27.4908C13.4655 31.1377 17.7318 33.5157 22.555 33.5157C30.5088 33.5157 36.9569 27.0551 36.9569 19.0858Z",
    fill: "#FFE266"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M25 39.6544C16.8269 39.6544 10.1785 32.9922 10.1785 24.8041C10.1785 16.616 16.8278 9.95373 25 9.95373C33.1722 9.95373 39.8215 16.616 39.8215 24.8041C39.8215 32.9922 33.1722 39.6544 25 39.6544ZM25 10.7936C17.2903 10.7936 11.0177 17.0784 11.0177 24.8031C11.0177 32.5278 17.2903 38.8127 25 38.8127C32.7097 38.8127 38.9823 32.5278 38.9823 24.8031C38.9823 17.0784 32.7097 10.7936 25 10.7936Z",
    fill: "#FCAB28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M15.0484 12.8009L16.3177 9.58875L17.5049 12.8449L19.7286 14.1166L17.461 15.3061L16.1918 19.3906L15.0046 15.2621L12.7808 13.9904L15.0484 12.8009Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83_469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.3e161584856e539ea21b2ca029459576.svg";
export { ForwardRef as ReactComponent };